import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#1A2332]" id="contact">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[#E8A020] text-xs font-bold tracking-widest uppercase">{t('contact_label')}</span>
          <h2 className="text-3xl md:text-4xl font-black text-white mt-3 mb-6">{t('contact_title')}</h2>
          <p className="text-white/60 text-base leading-relaxed max-w-2xl mx-auto">{t('contact_desc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/5 rounded-lg p-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-[#E8A020]/20 rounded-lg mx-auto mb-5">
              <i className="ri-map-pin-line text-[#E8A020] text-2xl" />
            </div>
            <div className="text-white font-semibold text-sm mb-2">{t('contact_address_label')}</div>
            <div className="text-white/60 text-sm whitespace-pre-line leading-relaxed">{t('contact_address_val')}</div>
          </div>

          <div className="bg-white/5 rounded-lg p-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-[#E8A020]/20 rounded-lg mx-auto mb-5">
              <i className="ri-phone-line text-[#E8A020] text-2xl" />
            </div>
            <div className="text-white font-semibold text-sm mb-2">{t('contact_phone_label')}</div>
            <a href="tel:+902122205256" className="block text-white/60 text-sm hover:text-[#E8A020] transition-colors">+90 212 220 52 56</a>
            <a href="tel:+905533585024" className="block text-white/60 text-sm mt-1 hover:text-[#E8A020] transition-colors">+90 553 358 50 24</a>
          </div>

          <div className="bg-white/5 rounded-lg p-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-[#E8A020]/20 rounded-lg mx-auto mb-5">
              <i className="ri-mail-line text-[#E8A020] text-2xl" />
            </div>
            <div className="text-white font-semibold text-sm mb-2">{t('contact_email_label')}</div>
            <a href="mailto:info@can-el.com" className="text-white/60 text-sm hover:text-[#E8A020] transition-colors">info@can-el.com</a>
          </div>
        </div>
      </div>
    </section>
  );
}